import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styles from './Subscription.module.scss';
import { Text, textVariantsEnum, fontWeightEnum } from '@/components/Text';
import { Button, buttonVariants } from '@/components/Button';
export const ExistingSubscriptionReplaceModal = ({ onConfirm, onClose }) => {
  const subscriptionData = useSelector(
    (state) => state?.auth?.profile?.subscription
  );
  const { subscriptionEndDate, cancelledAt } = useMemo(() => {
    return {
      subscriptionEndDate: subscriptionData?.subscriptionEndDate
        ?.toDate()
        .toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric',
        }),
      cancelledAt: subscriptionData?.cancelledAt
        ?.toDate()
        .toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric',
        }),
    };
  }, [subscriptionData]);
  return (
    <div className={styles.existingSubscriptionReplaceModal}>
      <Text
        variant={textVariantsEnum.Text_lg}
        fontWeight={fontWeightEnum.Semibold}
      >
        Replace Existing Subscription
      </Text>
      <Text
        variant={textVariantsEnum.Text_md}
        fontWeight={fontWeightEnum.Normal}
      >
        Your existing subscription was cancelled on{' '}
        <strong>{cancelledAt}</strong>.
      </Text>
      <Text
        variant={textVariantsEnum.Text_md}
        fontWeight={fontWeightEnum.Normal}
      >
        Subscription cycle ends on <strong>{subscriptionEndDate}</strong>.
      </Text>
      <Text
        variant={textVariantsEnum.Text_md}
        fontWeight={fontWeightEnum.Normal}
      >
        Would you like to replace it with the new subscription?
      </Text>
      <div className={styles.buttonsContainer}>
        <Button
          variant={buttonVariants.secondary}
          text="Cancel"
          onClick={onClose}
        />
        <Button
          variant={buttonVariants.primary}
          text="Confirm"
          onClick={onConfirm}
        />
      </div>
    </div>
  );
};
